export default "__VITE_ASSET__BrnpTGko__"